import * as Constants from "mapbox-gl-draw-geodesic/src/constants";
import {
  getCircleCenter,
  isCircle,
} from "mapbox-gl-draw-geodesic/src/utils/circle_geojson";
import { bearing, distance } from "mapbox-gl-draw-geodesic/src/utils/geodesy";
import createGeodesicGeojson from "mapbox-gl-draw-geodesic/src/utils/create_geodesic_geojson";
import { $bus } from "@/main";
import pinia, { useMap } from "@/services";

function patchDirectSelect(DirectSelect) {
  const DirectSelectPatched = { ...DirectSelect };
  let listener;

  DirectSelectPatched.dragVertex = function (state, e, delta) {
    const geojson = state.feature.toGeoJSON();

    if (isCircle(geojson)) {
      if (state.selectedCoordPaths[0] === "0.1") {
        const center = getCircleCenter(geojson);
        const handle = [e.lngLat.lng, e.lngLat.lat];
        const radius = distance(center, handle);
        state.feature[Constants.properties.CIRCLE_HANDLE_BEARING] = bearing(
          center,
          handle
        );
        state[Constants.properties.CIRCLE_RADIUS] = radius;
      } else {
        DirectSelect.dragFeature.call(this, state, e, delta);
      }
    } else {
      DirectSelect.dragVertex.call(this, state, e, delta);
      this.map.fire("draw.drawingUpdate", {
        features: [state.feature],
      });
    }
  };

  DirectSelectPatched.toDisplayFeatures = function (state, geojson, display) {
    const displayGeodesic = (gj) => {
      const geodesicGeojson = createGeodesicGeojson(gj, {
        ctx: this._ctx,
        selectedPaths: state.selectedCoordPaths,
      });
      geodesicGeojson.forEach(display);
    };
    DirectSelect.toDisplayFeatures.call(this, state, geojson, displayGeodesic);
  };

  DirectSelectPatched.onSetup = function (opts) {
    const state = DirectSelect.onSetup.call(this, opts);
    if (isCircle(state.feature.toGeoJSON())) {
      useMap(pinia).isEditingCircle = true;
      Object.defineProperty(state, Constants.properties.CIRCLE_RADIUS, {
        get() {
          return useMap(pinia).circleRadius;
        },
        set(value) {
          if (useMap(pinia).circleRadius !== value * 1e3) {
            useMap(pinia).circleRadius = value * 1e3;
          }
          state.feature.properties[Constants.properties.CIRCLE_RADIUS] =
            value || Number.EPSILON;
          state.feature.changed();
          const api = state.feature.ctx.api;
          api.add(api.getSelected());
        },
      });
      listener = $bus.$on("updateCircleRadius", (value) => {
        state[Constants.properties.CIRCLE_RADIUS] = value;
      });
    }
    return state;
  };

  DirectSelectPatched.onStop = function () {
    DirectSelect.onStop.call(this);
    useMap(pinia).isEditingCircle = false;
    $bus.$off("updateCircularRadius", listener);
  };

  return DirectSelectPatched;
}

export default patchDirectSelect;
